<template>
    <div>
        <el-form ref="form" label-width="20px" :model="formItem" :rules="rules" class="form-wrap">
            <el-form-item label="" prop="data_permission">
                <el-radio-group v-model="formItem.data_permission">
                    <el-radio v-for="item in dataPermissionList" :label="item.id" :key="item.id">{{item.display_name}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="tips font12px pl20">
            <p v-for="item in dataPermissionList"  :key="item.id">{{item.display_name}}：{{tipData[item.name]}}</p>
        </div>

        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div class="dialog-footer pt20 tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DataPermissionModal",
        props:{
            isView:Boolean,
            page:Object,
            cbs:{
                type:Object,
            },
        },
        data(){
            return {
                formItem:{
                    data_permission:'',
                },
                rules:{
                    data_permission:[
                        { required: true, message: '请选择', trigger: ['change'] }
                    ]
                },
                tipData: {
                    demand_side: '按照项目权限显示对应项目的所有素材与所有通用素材。',//需求方
                    producer: '按照制作人查看对应的素材。',//制作方
                    material_yy: '按照负责&授权账户获取账户权限+部门数据权限+媒体数据权限+页面数据权限',// 运营
                    material_cy: '按照素材制作人获取权限+部门数据权限+媒体数据权限+页面数据权限。',//创意
                    demand_side_perm:'查工单管理，能看到自己或自己有权限的部门创建的工单的数据。', // 需求方权限
                    creative_team_leader_perm:'查指派管理，能看到有权限的制作部门的工单的数据。', // 创意组长权限
                    producer_perm:'查任务管理，能看到指派给自己或有权限的成员的需求的数据。', // 制作人权限
                    sm_demand_perm:'排单管理，按需求方部门数据权限显示对应部门创建的工单。', // 排单·需求方
                    sm_creative_perm:'排单管理，按有权限的制作部门显示对应工单。', // 排单·创意组长
                    sm_producer_perm:'排单管理，按指派给自己或有权限成员的需求显示对应工单。', // 排单·制作人
                }
            }
        },
        computed:{
            dataPermissionList(){
                let page = this.page||{};
                return page.data_permission||[];
            },
        },
        mounted(){
            console.log('mounted',this.dataPermissionList);
            let checkedItem = this.dataPermissionList.find(item => item.checked === true);
            if(checkedItem){
                this.formItem.data_permission = checkedItem.id;
            }
        },
        methods:{
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        this.cbs.onSubmit({
                            data_permission:this.formItem.data_permission,
                        });
                        this.handleClose();
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
